import mainMenu from '@/navigation/mainMenu'

export default [...mainMenu]
